import { LocationService } from '../location/locationService';
import { Component, OnInit } from '@angular/core';
import { ClientService } from '../client/clientservice';
import { ClientCreate } from '../client/client';
import { Location } from '../location/location';
import { Router } from '@angular/router';


@Component({
  selector: 'app-clientcreate',
  templateUrl: './clientcreate.component.html',
  styleUrls: ['./clientcreate.component.css', '../app.component.less']
})

export class ClientcreateComponent implements OnInit {

  _client: ClientCreate = new ClientCreate;
  _location: Location = new Location;
  redirecturl: string;

  constructor(private clientservice: ClientService,
    private locationservice: LocationService,
    private router: Router,
  ) { }

  // PAGE LOAD
  ngOnInit(): void {
  }

  //  CREAT CLIENT WITH LOCATION 
  createClient() {
    try {
      if (this._client.name == null ||
        this._client.contact_name == null ||
        this._client.email == null ||
        this._location.addr1 == null ||
        this._location.addr2 == null ||
        this._location.City == null ||
        this._location.Country == null ||
        this._location.contact_name == null ||
        this._location.email == null) {
        window.alert("Please make sure you entered the correct data and try again!");
      } else {

        this.locationservice.createLocation(this._location).subscribe(resp => {
          var locs: number[] = [];
          locs.push(resp.id);
          this._client.locations = locs;
          this.clientservice.createClient(this._client).subscribe(resp => {
            this.redirecturl = "/clientviews/" + resp.id;
            this.router.navigateByUrl(this.redirecturl);
          });
        }
        );
      }
    }
    catch (e) {
      console.log(e);
    }
  }
}
